import PropTypes from "prop-types"
import { LabelDescriptionSelect } from "../../../components/tokenTester/LabelDescriptionSelect"
import { withLoading } from "./WithLoading"

const Selector = ({ caption, value, options, freeSolo, onChange }) =>
  options?.length > 0 || freeSolo ? (
    <LabelDescriptionSelect
      sx={{ paddingTop: "20px" }}
      helperText={caption}
      value={value}
      options={options || []}
      freeSolo={freeSolo}
      autoSelect
      handleChange={(_, value) => {
        if (value) {
          onChange(value)
        }
      }}
    />
  ) : null

Selector.propTypes = {
  caption: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  options: PropTypes.arrayOf(PropTypes.object),
  freeSolo: PropTypes.bool,
  onChange: PropTypes.func
}

export const EntitySelector = withLoading(Selector)
